var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Access denied "),_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/home","title":"Home"}},[_c('v-icon',{attrs:{"large":"","color":"green darken"}},[_vm._v("mdi-home")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }